var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounBack15364(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.082 100",
    enableBackground: "new 0 0 99.082 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.54,0C22.198-0.019,0.027,22.375,0,49.973C0.027,77.614,22.198,100.007,49.54,100  c27.352,0.007,49.521-22.386,49.542-50.027C99.062,22.375,76.892-0.019,49.54,0z M70.215,69.348c-1.205,1.908-4.28,1.232-3.25-1.625  c4.793-13.326-5.39-16.074-14.719-16.074c-3.847,0-7.219,0-7.219,0v13.07L21.232,45.037l23.795-19.679v13.07h2.525  C79.646,38.429,75.014,61.749,70.215,69.348z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounBack15364);
export default __webpack_public_path__ + "static/media/noun_back_15364.165deba0.svg";
export { ForwardRef as ReactComponent };